/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CarePrincipalDTO,
    CarePrincipalDTOFromJSON,
    CarePrincipalDTOFromJSONTyped,
    CarePrincipalDTOToJSON,
} from './CarePrincipalDTO';

/**
 * 
 * @export
 * @interface TransactionDTO
 */
export interface TransactionDTO {
    /**
     * 
     * @type {string}
     * @memberof TransactionDTO
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDTO
     */
    personId?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionDTO
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof TransactionDTO
     */
    transactionDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransactionDTO
     */
    registrationDateTime?: Date;
    /**
     * 
     * @type {CarePrincipalDTO}
     * @memberof TransactionDTO
     */
    carePrincipal?: CarePrincipalDTO;
    /**
     * 
     * @type {string}
     * @memberof TransactionDTO
     */
    careProvider?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDTO
     */
    careProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDTO
     */
    registeringCareProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDTO
     */
    careUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDTO
     */
    careUnitId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDTO
     */
    statusReason?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionDTO
     */
    status?: string;
}

export function TransactionDTOFromJSON(json: any): TransactionDTO {
    return TransactionDTOFromJSONTyped(json, false);
}

export function TransactionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionId': !exists(json, 'transactionId') ? undefined : json['transactionId'],
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'transactionDate': !exists(json, 'transactionDate') ? undefined : (new Date(json['transactionDate'])),
        'registrationDateTime': !exists(json, 'registrationDateTime') ? undefined : (new Date(json['registrationDateTime'])),
        'carePrincipal': !exists(json, 'carePrincipal') ? undefined : CarePrincipalDTOFromJSON(json['carePrincipal']),
        'careProvider': !exists(json, 'careProvider') ? undefined : json['careProvider'],
        'careProviderId': !exists(json, 'careProviderId') ? undefined : json['careProviderId'],
        'registeringCareProviderId': !exists(json, 'registeringCareProviderId') ? undefined : json['registeringCareProviderId'],
        'careUnit': !exists(json, 'careUnit') ? undefined : json['careUnit'],
        'careUnitId': !exists(json, 'careUnitId') ? undefined : json['careUnitId'],
        'statusReason': !exists(json, 'statusReason') ? undefined : json['statusReason'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function TransactionDTOToJSON(value?: TransactionDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactionId': value.transactionId,
        'personId': value.personId,
        'amount': value.amount,
        'transactionDate': value.transactionDate === undefined ? undefined : (value.transactionDate.toISOString().substr(0,10)),
        'registrationDateTime': value.registrationDateTime === undefined ? undefined : (value.registrationDateTime.toISOString()),
        'carePrincipal': CarePrincipalDTOToJSON(value.carePrincipal),
        'careProvider': value.careProvider,
        'careProviderId': value.careProviderId,
        'registeringCareProviderId': value.registeringCareProviderId,
        'careUnit': value.careUnit,
        'careUnitId': value.careUnitId,
        'statusReason': value.statusReason,
        'status': value.status,
    };
}

